import { jsx } from "panel";
const SelectionSegment = ({
  selectionLayout,
  selectionClass,
  component
}) => {
  return /* @__PURE__ */ jsx(null, null, selectionLayout.segments.map((segment) => /* @__PURE__ */ jsx("div", {
    sel: ".selection-segment",
    class: {
      "start-rounded": segment.startRounded,
      "end-rounded": segment.endRounded,
      [selectionClass || void 0]: !!selectionClass
    },
    style: {
      background: component.helpers.getSelectionSegmentBackground(segment),
      "grid-row": segment.rowStart.toString(),
      "grid-column": `${segment.columnStart} / span ${segment.columnSpan}`,
      margin: `${segment.verticalMarginPx}px 0`
    }
  })));
};
export function template() {
  const weekdayLabels = this.helpers.getOrderedWeekdayLabels();
  const monthGridLayout = this.helpers.getVisibleMonthGridLayout();
  const selectionLayout = this.helpers.getSelectionLayout();
  const previewSelectionLayout = this.helpers.getPreviewSelectionLayout();
  const todayKey = this.helpers.getTodayKey();
  return /* @__PURE__ */ jsx("div", {
    sel: ".scroll-container",
    attrs: {
      elref: `scrollContainer`
    },
    hook: {
      postpatch: this.helpers.handleScrollContainerPostpatch
    },
    on: {
      mousedown: this.helpers.handleScrollContainerMousedown
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".content-wrapper"
  }, /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".header-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".week-header",
    style: {
      height: `${this.helpers.HEADER_HEIGHT_PX}px`,
      "grid-template-columns": `repeat(7, ${this.helpers.ROW_HEIGHT_PX}px)`
    }
  }, weekdayLabels.map((label) => /* @__PURE__ */ jsx("div", {
    sel: ".weekday-heading"
  }, label)))), /* @__PURE__ */ jsx("div", {
    sel: ".grid-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".month-grid",
    style: {
      "grid-template-rows": `repeat(${monthGridLayout.rowHeight}, ${this.helpers.ROW_HEIGHT_PX}px)`,
      "grid-template-columns": `repeat(7, ${this.helpers.ROW_HEIGHT_PX}px)`
    },
    on: {
      click: this.helpers.handleDelegatedClickHandler
    },
    hook: {
      insert: (vnode) => {
        vnode.elm.addEventListener(`mouseenter`, this.helpers.handleDelegatedMouseEnterHandler, true);
        vnode.elm.addEventListener(`mouseleave`, this.helpers.handleDelegatedMouseLeaveHandler, true);
      },
      destroy: (vnode) => {
        vnode.elm.removeEventListener(`mouseenter`, this.helpers.handleDelegatedMouseEnterHandler, true);
        vnode.elm.removeEventListener(`mouseleave`, this.helpers.handleDelegatedMouseLeaveHandler, true);
      }
    }
  }, /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".canary",
    key: "top-canary",
    style: {
      "grid-row": `1 / span ${monthGridLayout.topCanaryRowStart}`
    },
    hook: { insert: this.helpers.handleTopCanaryInsert }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".canary",
    key: "bottom-canary",
    style: {
      "grid-row": `${monthGridLayout.bottomCanaryRowStart} / span ${monthGridLayout.rowHeight - monthGridLayout.bottomCanaryRowStart}`
    },
    hook: { insert: this.helpers.handleBottomCanaryInsert }
  }), selectionLayout ? /* @__PURE__ */ jsx(SelectionSegment, {
    selectionLayout,
    selectionClass: null,
    component: this
  }) : null, previewSelectionLayout ? /* @__PURE__ */ jsx(SelectionSegment, {
    selectionLayout: previewSelectionLayout,
    selectionClass: `preview`,
    component: this
  }) : null, Array.from(monthGridLayout.months.values()).map((month) => /* @__PURE__ */ jsx("div", {
    sel: ".month-label",
    style: {
      "grid-row": `${month.rowStart}`
    }
  }, month.label)), Array.from(monthGridLayout.days.keys()).map((dayKey) => {
    const day = monthGridLayout.days.get(dayKey);
    const selectionSegment = this.helpers.getSelectionSegmentForDayKey(dayKey, selectionLayout);
    const previewSelectionSegment = this.helpers.getSelectionSegmentForDayKey(
      dayKey,
      previewSelectionLayout
    );
    const segmentType = (previewSelectionSegment || selectionSegment) && (previewSelectionSegment || selectionSegment).segmentType;
    const isToday = todayKey === dayKey;
    return /* @__PURE__ */ jsx("div", {
      sel: ".day-of-month-square-container",
      key: dayKey,
      attrs: {
        elref: `cell_${day.columnStart}_${day.rowStart}`
      },
      class: { disabled: day.disabled },
      style: {
        "grid-column": `${day.columnStart}`,
        "grid-row": `${day.rowStart}`
      },
      props: {
        calendarDay: day.calendarDay
      }
    }, /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".day-of-month",
      attrs: isToday ? { "data-text": day.calendarDay.isoDayOfMonth } : {},
      class: {
        today: isToday,
        "preview-segment": !!previewSelectionSegment,
        "segment-highlight": segmentType === this.helpers.SelectionSegmentType.Highlight,
        "segment-offset": segmentType === this.helpers.SelectionSegmentType.Offset,
        "segment-fill": segmentType === this.helpers.SelectionSegmentType.Fill
      }
    }, day.calendarDay.isoDayOfMonth), this.helpers.renderDayTooltip(day.calendarDay)));
  })))))));
}
